(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.filter('ThirdPartyFilter', ['ThirdPartyEnum', ThirdPartyFilterFn]);

    // get Name from ThirdParty Constants by value
    function ThirdPartyFilterFn(ThirdPartyEnum) {

        return function (value) {

            var ret = value;

            if (typeof value !== 'undefined' && value !== null) {

                angular.forEach(ThirdPartyEnum, function (item) {
                    if (value === item.value)
                        ret = item.name;
                });

                return ret;

            }
        };
    }
})();
